export type EmployeeAttempt = { id: number; version: number; action: string }

export function readEmployeeAttempt(key: string): EmployeeAttempt | null {
  const raw = sessionStorage.getItem(key)
  if (!raw) return null
  const value: unknown = JSON.parse(raw)
  if (!value || typeof value !== 'object' || !('id' in value) || !('version' in value)
    || !('action' in value) || typeof value.id !== 'number' || !Number.isSafeInteger(value.id)
    || value.id <= 0 || typeof value.version !== 'number' || !Number.isSafeInteger(value.version)
    || value.version < 0 || typeof value.action !== 'string' || value.action.length > 300) {
    throw new Error('Повреждена запись предыдущего действия. Обратитесь в поддержку; новые изменения не отправлены.')
  }
  return value as EmployeeAttempt
}
